export const CompanyOptions = [
  { label: "Vella", value: "Vella" },
  { label: "98 Acres", value: "98 Acres" },
  { label: "Ravana Pool Club", value: "Ravana Pool Club" },
  { label: "Flying Ravana", value: "Flying Ravana" },
  { label: "Le Maas Tota", value: "Le Maas Tota" },
  { label: "Tea Factory", value: "Tea Factory" },
  { label: "Walaa kulu", value: "Walaa kulu" },
  { label: "Kiri Kopi", value: "Kiri Kopi" },
  { label: "Halpe Tea", value: "Halpe Tea" },
  { label: "Ambuluwawa Swing", value: "Ambuluwawa Swing" },
  { label: "Ella Swing", value: "Ella Swing" },
  { label: "Lucha Lucha", value: "Lucha Lucha" },
  { label: "UHE Plantation", value: "UHE Plantation" },
  { label: "UHE Exports", value: "UHE Exports" },
  {label: "UVA Halpewatte", value: "UVA Halpewatte" },
];
